import React from 'react';
import { Grid, Box, Typography, Divider, Chip, Stack } from '@mui/material';
import { PillButton } from '../../../components/superAdminUi';
import FormSectionHeader from '../../../components/common/FormSectionHeader';

const Fact = ({ label, value }) => (
  <Stack direction="row" justifyContent="space-between" sx={{ mb: 0.5 }}>
    <Typography variant="body2" color="text.secondary">{label}</Typography>
    <Typography variant="body2" sx={{ fontWeight: 500 }}>{value || '—'}</Typography>
  </Stack>
);

// Step 4: read-only recap. The Create action lives in the wizard footer; on success this
// swaps to a confirmation panel (structured failures surface via the page's banner while
// field-level errors are routed to their steps).
export default function ReviewStep({ values, schools, created, onGoToGroup }) {
  const existing = schools.filter((row) => row.source === 'gias' && !row.dirty);
  const newSchools = schools.filter((row) => row.source !== 'gias' || row.dirty);
  const products = values.products || [];

  if (created) {
    return (
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <Typography variant="h6" sx={{ mb: 1 }}>Group added successfully</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {values.Name} has been created with {existing.length + newSchools.length} school(s).
        </Typography>
        <PillButton type="button" $variant="danger" $size="lg" onClick={onGoToGroup}>Go to group</PillButton>
      </Box>
    );
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <FormSectionHeader title="Review & create" first />
      </Grid>

      <Grid item xs={12} md={6}>
        <Typography variant="subtitle2" sx={{ mb: 1 }}>Group</Typography>
        <Fact label="Name" value={values.Name} />
        <Fact label="Director" value={`${values.FirstName || values.GroupName} ${values.LastName || values.GroupName}`} />
        <Fact label="Type" value={values.GroupType} />
        <Fact label="Country" value={values.Country} />
        <Fact label="Storage" value={values.DataStorageLocation} />
      </Grid>

      <Grid item xs={12} md={6}>
        <Typography variant="subtitle2" sx={{ mb: 1 }}>Subscription</Typography>
        <Fact label="Term" value={values.SubscriptionTerm ? `${values.SubscriptionTerm} year(s)` : '—'} />
        <Fact label="Multi-year" value={values.IsMultiYear ? 'Yes' : 'No'} />
        <Fact label="VAT" value={`${values.VatPercentApplied || 0}%`} />
        <Box sx={{ mt: 1 }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>Products</Typography>
          <Stack direction="row" spacing={0.5} flexWrap="wrap">
            {products.length === 0 ? (
              <Typography variant="body2">—</Typography>
            ) : (
              products.map((product) => <Chip key={product} size="small" label={product} />)
            )}
          </Stack>
        </Box>
      </Grid>

      <Grid item xs={12}>
        <Divider sx={{ my: 1 }} />
        <Typography variant="subtitle2">
          Schools: {existing.length} existing, {newSchools.length} new
        </Typography>
      </Grid>
    </Grid>
  );
}
